module.exports = Ember.HTMLBars.template((function() {
  return {
    isHTMLBars: true,
    revision: "Ember@1.11.1",
    blockParams: 0,
    cachedFragment: null,
    hasRendered: false,
    build: function build(dom) {
      var el0 = dom.createDocumentFragment();
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","led month");
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","led day");
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","led year");
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","led hour");
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","led minute");
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      var el1 = dom.createElement("img");
      dom.setAttribute(el1,"src","images/time-machine-panel.png");
      dom.setAttribute(el1,"class","panel");
      dom.appendChild(el0, el1);
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","controls");
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      return el0;
    },
    render: function render(context, env, contextualElement) {
      var dom = env.dom;
      var hooks = env.hooks, content = hooks.content, get = hooks.get, inline = hooks.inline;
      dom.detectNamespace(contextualElement);
      var fragment;
      if (env.useFragmentCache && dom.canClone) {
        if (this.cachedFragment === null) {
          fragment = this.build(dom);
          if (this.hasRendered) {
            this.cachedFragment = fragment;
          } else {
            this.hasRendered = true;
          }
        }
        if (this.cachedFragment) {
          fragment = dom.cloneNode(this.cachedFragment, true);
        }
      } else {
        fragment = this.build(dom);
      }
      var element0 = dom.childAt(fragment, [6]);
      var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
      var morph1 = dom.createMorphAt(dom.childAt(fragment, [1]),0,0);
      var morph2 = dom.createMorphAt(dom.childAt(fragment, [2]),0,0);
      var morph3 = dom.createMorphAt(dom.childAt(fragment, [3]),0,0);
      var morph4 = dom.createMorphAt(dom.childAt(fragment, [4]),0,0);
      var morph5 = dom.createMorphAt(element0,0,0);
      var morph6 = dom.createMorphAt(element0,1,1);
      var morph7 = dom.createMorphAt(element0,2,2);
      var morph8 = dom.createMorphAt(element0,3,3);
      content(env, morph0, context, "month");
      content(env, morph1, context, "day");
      content(env, morph2, context, "year");
      inline(env, morph3, context, "sm-numeral", [], {"format": "00", "animated": true, "animationDuration": 350, "value": get(env, context, "hour")});
      inline(env, morph4, context, "sm-numeral", [], {"format": "00", "animated": true, "animationDuration": 350, "value": get(env, context, "minute")});
      inline(env, morph5, context, "sm-button", [], {"text": "-30 мин", "classNames": "bordered-orange small", "action": "minusThirtyMinutes"});
      inline(env, morph6, context, "sm-button", [], {"text": "-5 мин", "classNames": "bordered-orange small", "action": "minusFiveMinutes"});
      inline(env, morph7, context, "sm-button", [], {"text": "+5 мин", "classNames": "bordered-gray small", "action": "plusFiveMinutes"});
      inline(env, morph8, context, "sm-button", [], {"text": "+30 мин", "classNames": "bordered-gray small", "action": "plusThirtyMinutes"});
      return fragment;
    }
  };
}()));